import React, { useState, useEffect } from 'react'
import { BUTTON_THEME, Button } from '@st-operations/uikit/src/v2'

import { getPermissionSets } from '_services/permissions'
import { useModal } from '_hooks'
import { AddDatasphereFlagModal } from './AddDatasphereFlagModal.jsx'
import { AddDatasphereAdminModal } from './AddDatasphereAdminModal.jsx'
import { PermissionSetItem } from './PermissionSetItem.jsx'

export function PermissionSets() {
  const [permissionSets, setPermissionSets] = useState([])
  const admin = useModal(false)
  const flag = useModal(false)

  useEffect(() => {
    async function fetchPermissionSets() {
      const response = await getPermissionSets()
      setPermissionSets(response.items)
    }

    fetchPermissionSets()
  }, [])

  return (
    <section className="use-preflight">
      <header className="flex items-center gap-2">
        <h1 className="header-3">Permission sets</h1>

        <div className="flex gap-2 ml-auto my-8">
          <Button
            className="whitespace-nowrap m-0"
            theme={BUTTON_THEME.SECONDARY}
            onClick={flag.handleOpenModal}
          >
            Add DataSphere flag
          </Button>
          <Button
            className="whitespace-nowrap m-0"
            theme={BUTTON_THEME.SECONDARY}
            onClick={admin.handleOpenModal}
          >
            Add DataSphere admin
          </Button>
        </div>
      </header>

      <table className="border border-gray rounded-lg w-full border-separate my-4">
        <thead>
          <tr className="bg-gray-200 text-left border-b border-gray">
            <th className="header-4 py-2 pl-4">Application</th>
            <th className="header-4 pl-4 py-2">Group</th>
            <th className="w-[24px]">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          {permissionSets.map((permissionSet) => (
            <PermissionSetItem
              key={permissionSet._id}
              id={permissionSet._id}
              application={permissionSet.application}
              name={permissionSet.name}
            />
          ))}
        </tbody>
      </table>
      <If condition={admin.isOpen}>
        <AddDatasphereAdminModal onClose={admin.handleCloseModal} />
      </If>
      <If condition={flag.isOpen}>
        <AddDatasphereFlagModal onClose={flag.handleCloseModal} />
      </If>
    </section>
  )
}
